var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutobeGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 3.23529V7.76471L10.6667 5.49224L6.66667 3.23529ZM15.84 8.62724C15.84 8.62724 15.6833 9.70459 15.204 10.1795C14.5953 10.8026 13.9133 10.8052 13.6007 10.8415C11.362 11 8.00333 11 8.00333 11H7.99667C7.99667 11 4.638 11 2.39933 10.8415C2.086 10.8052 1.40467 10.8026 0.795333 10.1795C0.316 9.70459 0.16 8.62659 0.16 8.62659C0.16 8.62659 0 7.36224 0 6.09724V4.90988C0 3.64424 0.16 2.37859 0.16 2.37859C0.16 2.37859 0.316 1.30124 0.795333 0.826294C1.40467 0.203176 2.204 0.223235 2.56 0.157882C3.84 0.0368824 8 0 8 0C8 0 11.362 0.00517654 13.6007 0.163059C13.914 0.199942 14.5953 0.20253 15.204 0.825647C15.684 1.30059 15.84 2.37859 15.84 2.37859C15.84 2.37859 16 3.64359 16 4.90924V6.09594C16 7.36159 15.84 8.62724 15.84 8.62724Z",
    fill: "#808191"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutobeGray);
export default __webpack_public_path__ + "static/media/youtobe_gray.62e8fe1d.svg";
export { ForwardRef as ReactComponent };